// extracted by mini-css-extract-plugin
module.exports = {"terms-page":"styles_terms-page__3TUQQ","terms-page-body":"styles_terms-page-body__2aJKx","last-modified":"styles_last-modified__1f64K"};